<template>
  <div class="terms">
    <MainNav />
    <div class="jumbotron jumbotron-fluid bg-light">
      <div class="container">
        <h1>Terms and Conditions</h1>
      </div>
    </div>
    <div class="container">
      <h2>
        THE CUSTOMER'S ATTENTION IS PARTICULARLY DRAWN TO THE PROVISIONS OF
        CLAUSE 10 (LIMITATIONOF LIABILITY).
      </h2>
      <br />
      <div class="row">
        <div id="1.0" class="col-1"><h2>1.</h2></div>
        <div class="col-11"><h3>INTERPRETATION</h3></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            The following definitions and rules of interpretation apply in these
            Conditions.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="1.1" class="col-1"><h5>1.1</h5></div>
        <div class="col-11"><p>Definitions:</p></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Account</strong></p>
        </div>
        <div class="col-8">
          <p>
            the account that each Customer must apply for, to access the Portal
            and place Orders.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Biological Records</strong></p>
        </div>
        <div class="col-8">
          <p>
            means the spatial and temporal data on wildlife species and habitats
            collected by ERCCIS or CWT for their own habitats or provided by
            third parties and collated, managed and maintained by ERCCIS or CWT.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Business Day</strong></p>
        </div>
        <div class="col-8">
          <p>
            a day other than a Saturday, Sunday or public holiday in England,
            when banks in London are open for business.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Contract</strong></p>
        </div>
        <div class="col-8">
          <p>
            the contract between ERCCIS and the Customer for the supply of
            Services in accordance with these Terms.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Customer</strong></p>
        </div>
        <div class="col-8">
          <p>the person or firm who purchases Services from ERCCIS.</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Customer Default</strong></p>
        </div>
        <div class="col-8">
          <p>has the meaning set out in clause <a href="#5.3">5.3.</a></p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>CWT</strong></p>
        </div>
        <div class="col-8">
          <p>
            Cornwall Trust for Nature Conservation Ltd (The) trading as Cornwall
            Wildlife Trust, registeredin England and Wales with company number
            00732511 whose registered address is Five Acres, Allet, Truro,
            Cornwall, TR4 9DJ.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>ERCISS</strong></p>
        </div>
        <div class="col-8">
          <p>
            the Environmental Records Centre for Cornwall and the Isles of
            Scilly, a department of CWT.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>ERCCIS Terms of Use</strong></p>
        </div>
        <div class="col-8">
          <p>
            Means the ERCCIS terms of use which can be found
            <a href="https://erccis.org.uk/aboutus/Policies" target="_blank"
              >here</a
            >.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Data Protection Legislation</strong></p>
        </div>
        <div class="col-8">
          <p>
            all applicable data protection and privacy legislation in force from
            time to time in the UK including the General Data Protection
            Regulation ((EU) 2016/679); the Data Protection Act 2018; the
            Privacy and Electronic Communications Directive (2002/58/EC) (as
            updated by Directive 2009/136/EC) and the Privacy and Electronic
            Communications Regulations 2003 (SI 2003/2426) as amended and any
            other European Union legislation relating to personal data and all
            other legislation and regulatory requirements in force from time to
            time which apply to a party relating to the use of personal data and
            the guidance and codes of practice issued by the relevant data
            protection or supervisory authority and applicable to a party. The
            following terms are as defined in the Data Protection Legislation;
            controller, processor, data subject, personal data, personal data
            breach, processing and appropriate technical measures.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>ERCCIS Data Search (EDS)</strong></p>
        </div>
        <div class="col-8">
          <p>
            an online search tool providing access to the Biological Records via
            the Portal.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Intellectual Property Rights</strong></p>
        </div>
        <div class="col-8">
          <p>
            patents, utility models, rights to inventions, copyright and
            neighbouring and related rights, moral rights, trademarks and
            service marks, business names and domain names, rights in get-up and
            trade dress, goodwill and the right to sue for passing off or unfair
            competition, rights in designs, rights in computer software,
            database rights, rights to use, and protect the confidentiality of,
            confidential information (including know-how and trade secrets), and
            all other intellectual property rights, in each case whether
            registered or unregistered and including all applications and rights
            to apply for and be granted, renewals or extensions of, and rights
            to claim priority from, such rights and all similar or equivalent
            rights or forms of protection which subsist or will subsist now or
            in the future in any part of the world.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Order(s)</strong></p>
        </div>
        <div class="col-8">
          <p>
            the Customer's order for Services including but not limited to EDS.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Prices</strong></p>
        </div>
        <div class="col-8">
          <p>
            the charges payable by the Customer for the supply of the Services
            in accordance with <a href="#7.0">Clause 7</a>.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Portal</strong></p>
        </div>
        <div class="col-8">
          <p>
            the online software application and software as a service provided
            by ERCCIS through which the Biological Records, EDS service and
            other Services can be accessed.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Services</strong></p>
        </div>
        <div class="col-8">
          <p>
            the services supplied by ERCCIS to the Customer, including but not
            limited to, access to the Biological Records, Portal and provision
            of EDS.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-3">
          <p><strong>Terms</strong></p>
        </div>
        <div class="col-8">
          <p>
            these terms and conditions as amended from time to time in
            accordance with <a href="#15.0">Clause 15</a>.
          </p>
        </div>
      </div>

      <div class="row">
        <div id="1.2" class="col-1"><h5>1.2</h5></div>
        <div class="col-11"><p>Interpretation:</p></div>
      </div>
      <div class="row justify-content-end">
        <div id="1.2.1" class="col-1"><h5>1.2.1</h5></div>
        <div class="col-10">
          <p>
            A reference to a statute or statutory provision is a reference to it
            as amended or re-enacted. A reference to a statute or statutory
            provision includes all subordinate legislation made under that
            statute or statutory provision.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="1.2.2" class="col-1"><h5>1.2.2</h5></div>
        <div class="col-10">
          <p>
            Any words following the terms
            <strong>including, include, in particular, for example</strong> or
            any similar expression, shall be construed as illustrative and shall
            not limit the sense of the words, description, definition, phrase or
            term preceding those terms.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="1.2.3" class="col-1"><h5>1.2.3</h5></div>
        <div class="col-10">
          <p>
            A reference to <strong>writing</strong> or
            <strong>written</strong> includes email but not fax.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="1.2.4" class="col-1"><h5>1.2.4</h5></div>
        <div class="col-10">
          <p>
            If you have a Service Level Agreement (SLA) with us these terms will
            also apply to your use of the Portal and in the event of any
            conflict between these terms and the terms of your SLA these terms
            shall take precedence.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="2.0" class="col-1"><h2>2.</h2></div>
        <div class="col-11"><h3>UPLOAD OF RECORDS</h3></div>
      </div>
      <div class="row">
        <div id="2.1" class="col-1"><h5>2.1</h5></div>
        <div class="col-11">
          <p>
            Should the Customer wish to upload Biological Records, they must:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="2.1.1" class="col-1"><h5>2.1.1</h5></div>
        <div class="col-10">
          <p>
            abide by the ERCCIS’ Behaviours/Best Practices guidance set out in
            our <a href="/user-guide">User Guide</a>.
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="2.1.2" class="col-1"><h5>2.1.2</h5></div>
        <div class="col-10">
          <p>
            abide by the ERCCIS
            <a href="/terms-and-conditions">Terms of Use</a>; and
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="2.1.3" class="col-1"><h5>2.1.3</h5></div>
        <div class="col-10">
          <p>
            ensure that the Biological Records are accurate as of the date the
            information was collected.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="3.0" class="col-1"><h2>3.</h2></div>
        <div class="col-11"><h3>PORTAL ACCOUNTS</h3></div>
      </div>
      <div class="row">
        <div id="3.1" class="col-1"><h5>3.1</h5></div>
        <div class="col-11">
          <p>
            Each Customer must apply for an individual Account to access the
            Portal. Once the Account has been approved by ERCCIS, the Customer
            can access the Services and place an Order.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="3.2" class="col-1"><h5>3.2</h5></div>
        <div class="col-11">
          <p>
            The Order constitutes an offer by the Customer to purchase Services
            in accordance with these Terms.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="3.3" class="col-1"><h5>3.3</h5></div>
        <div class="col-11">
          <p>
            The Order shall only be deemed to be accepted when ERCCIS issues its
            invoice.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="3.4" class="col-1"><h5>3.4</h5></div>
        <div class="col-11">
          <p>
            These Terms apply to the Contract to the exclusion of any other
            terms that the Customer seeks to impose or incorporate, or which are
            implied by trade, custom, practice or course of dealing.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="3.5" class="col-1"><h5>3.5</h5></div>
        <div class="col-11">
          <p>
            ERCCIS reserves the right to review Account usage and where an
            Account has been inactive for over 2 years, ERCCIS will write to the
            Customer alerting them to inactivity. If no response is received
            from the Customer within 2 months of thewritten notice being issued,
            ERCCIS may delete the Account.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="4.0" class="col-1"><h2>4.</h2></div>
        <div class="col-11"><h3>CUSTOMER'S OBLIGATIONS</h3></div>
      </div>
      <div class="row">
        <div id="4.1" class="col-1"><h5>4.1</h5></div>
        <div class="col-11"><p>The Customer shall:</p></div>
      </div>
      <div class="row justify-content-end">
        <div id="4.1.1" class="col-1"><h5>4.1.1</h5></div>
        <div class="col-10">
          <p>
            ensure that the terms of the Order and any information it provides
            is complete and accurate;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.1.2" class="col-1"><h5>4.1.2</h5></div>
        <div class="col-10">
          <p>co-operate with ERCCIS in all matters relating to the Services;</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.1.3" class="col-1"><h5>4.1.3</h5></div>
        <div class="col-10">
          <p>only use the Services for the purposes they were designed for;</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.1.4" class="col-1"><h5>4.1.4</h5></div>
        <div class="col-10">
          <p>adhere to the ERCCIS Terms of Use at all times;</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.1.5" class="col-1"><h5>4.1.5</h5></div>
        <div class="col-10">
          <p>hereby warrant that they are over the age of 18;</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.1.6" class="col-1"><h5>4.1.6</h5></div>
        <div class="col-10">
          <p>
            use reasonable endeavours to prevent any unauthorised access to, or
            use of, Portal and notify ERCCIS promptly of any such unauthorised
            access or use;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.1.7" class="col-1"><h5>4.1.7</h5></div>
        <div class="col-10">
          <p>
            ensure that any passwords or other credentials are kept
            confidential.
          </p>
        </div>
      </div>

      <div class="row">
        <div id="4.2" class="col-1"><h5>4.2</h5></div>
        <div class="col-11">
          <p>
            The Customer shall not (except where ERCCIS have expressly given
            permission for the Customer to do so):
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.2.1" class="col-1"><h5>4.2.1</h5></div>
        <div class="col-10">
          <p>
            access all or any part of the Services in order to build a product
            or service which competes with the Services; or
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.2.2" class="col-1"><h5>4.2.2</h5></div>
        <div class="col-10">
          <p>use the Services to provide services to third parties; or</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.2.3" class="col-1"><h5>4.2.3</h5></div>
        <div class="col-10">
          <p>
            license, sell, rent, lease, transfer, assign, distribute, display,
            disclose, or otherwise commerciallyexploit, or otherwise make the
            Portal available to any third party; or
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="4.2.4" class="col-1"><h5>4.2.4</h5></div>
        <div class="col-10">
          <p>
            attempt to obtain, or assist third parties in obtaining, access to
            the Services, other than as provided under this clause 4.
          </p>
        </div>
      </div>

      <div class="row">
        <div id="4.3" class="col-1"><h5>4.3</h5></div>
        <div class="col-11">
          <p>
            ERCCIS grants permission for the Customer to share the Services with
            a third party (e.g. where the Customer is acting as a consultant to
            a third party), the third party must be subject to terms similar to,
            and no less onerous than the provisions of this clause 4.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="5.0" class="col-1"><h2>5.</h2></div>
        <div class="col-11"><h3>ERCCIS OBLIGATIONS</h3></div>
      </div>
      <div class="row">
        <div id="5.1" class="col-1"><h5>5.1</h5></div>
        <div class="col-11">
          <p>
            ERCCIS shall supply the Services to the Customer in all material
            respects and will be provided using reasonable care and skill.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="5.2" class="col-1"><h5>5.2</h5></div>
        <div class="col-11">
          <p>
            ERCCIS reserves the right to amend the Services if necessary to
            comply with any applicable law or regulatory requirement, or if the
            amendment will not materially affect the nature or quality of the
            Services and ERCCIS shall notify the Customer in any such event.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="5.3" class="col-1"><h5>5.3</h5></div>
        <div class="col-11">
          <p>
            If ERCCIS's performance of any of its obligations under the Contract
            is prevented or delayed by any act or omission by the Customer or
            failure by the Customer to perform any relevant obligation (<strong
              >Customer Default</strong
            >):
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="5.3.1" class="col-1"><h5>5.3.1</h5></div>
        <div class="col-10">
          <p>
            without limiting or affecting any other right or remedy available to
            it, ERCCIS shall have the right to suspend performance of the
            Services until the Customer remedies the Customer Default, and to
            rely on the Customer Default to relieve it from the performance of
            any of its obligations in each case to the extent the Customer
            Default prevents or delays ERCCIS's performance of any of its
            obligations;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="5.3.2" class="col-1"><h5>5.3.2</h5></div>
        <div class="col-10">
          <p>
            ERCCIS shall not be liable for any costs or losses sustained or
            incurred by the Customer arising directly or indirectly from
            ERCCIS's failure or delay to perform any of its obligations as set
            out in this clause 5.3; and
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="5.3.3" class="col-1"><h5>5.3.3</h5></div>
        <div class="col-10">
          <p>
            the Customer shall reimburse ERCCIS on written demand for any costs
            or losses sustained or incurred by ERCCIS arising directly or
            indirectly from the Customer Default.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="6.0" class="col-1"><h2>6.</h2></div>
        <div class="col-11"><h3>EDS SERVICE</h3></div>
      </div>
      <div class="row">
        <div id="6.1" class="col-1"><h5>6.1</h5></div>
        <div class="col-11">
          <p>
            The Customer must select a search level via the map contained within
            the Account. The Customer shall place a pin in the map and select
            the geographical radius option; the EDS will then be applied to the
            selected area.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="6.2" class="col-1"><h5>6.2</h5></div>
        <div class="col-11">
          <p>
            ERCCIS will aim to provide the EDS results within 30 minutes of the
            Order confirmation. If there is a delay for any reason, ERCCIS will
            whenever possible aim to contact the Customer with an updated
            timescale for providing the EDS results.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="6.3" class="col-1"><h5>6.3</h5></div>
        <div class="col-11">
          <p>
            The Customer hereby acknowledges that the information available via
            the EDS is collated by a number of third parties and therefore
            ERCCIS cannot guarantee that:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="6.3.1" class="col-1"><h5>6.3.1</h5></div>
        <div class="col-10">
          <p>the Biological Records are complete and/or accurate;</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="6.3.2" class="col-1"><h5>6.3.2</h5></div>
        <div class="col-10">
          <p>
            the species detailed in the Biological Records continue to be
            present in the area recorded; and
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="6.3.3" class="col-1"><h5>6.3.3</h5></div>
        <div class="col-10">
          <p>
            the lack of a species being present in a Record correlates with
            there being a low biodiversity value or absence of the species in
            the EDS geographical area.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="7.0" class="col-1"><h2>7.</h2></div>
        <div class="col-11"><h3>PRICES AND PAYMENT</h3></div>
      </div>
      <div class="row">
        <div id="7.1" class="col-1"><h5>7.1</h5></div>
        <div class="col-11">
          <p>
            Prices for the various Services are detailed at
            <a href="https://erccis.org.uk/AboutUs/Policies"
              >https://erccis.org.uk/AboutUs/Policies</a
            >.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="7.2" class="col-1"><h5>7.2</h5></div>
        <div class="col-11">
          <p>
            ERCCIS reserves the right to increase the Prices on an annual basis
            in line with the percentage increase in the Retail Prices Index.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="7.3" class="col-1"><h5>7.3</h5></div>
        <div class="col-11">
          <p>
            All payments for Orders will be required upfront and by credit/debit
            card.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="7.4" class="col-1"><h5>7.4</h5></div>
        <div class="col-11">
          <p>
            Only where expressly permitted by ERCCIS, the Customer may request
            payment be made on receipt of an invoice.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="7.5" class="col-1"><h5>7.5</h5></div>
        <div class="col-11">
          <p>
            Where permitted, the Customer will pay each invoice submitted by
            ERCCIS within 30 days of the date of the invoice and in full and
            incleared funds to a bank account nominated in writing by ERCCIS.
            Time for payment shall be of the essence of the Contract.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="7.6" class="col-1"><h5>7.6</h5></div>
        <div class="col-11">
          <p>
            All amounts payable by the Customer under the Contract are exclusive
            of amounts in respect of value added tax chargeable from time totime
            (VAT). Where any taxable supply for VAT purposes is made under the
            Contract by ERCCIS to the Customer, the Customer shall, on receipt
            of a valid VAT invoice from ERCCIS, pay to ERCCIS such additional
            amounts in respect of VAT as are chargeable on thesupply of the
            Services at the same time as payment is due for the supply of the
            Services.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="7.7" class="col-1"><h5>7.7</h5></div>
        <div class="col-11">
          <p>
            If the Customer fails to make a payment due to ERCCIS under the
            Contract by the due date, then, without limiting the ERCCIS's
            remedies under <a href="11.0">Clause 11</a>, the Customer shall pay
            interest on the overdue sum from the due date until payment of the
            overdue sum, whether before or after judgment. Interest under this
            clause 7.7 will accrue each day at a rate of 8% a year above the
            Bank of England's base rate from time to time, but at 8% a year for
            any period when that base rate is below 0%. An additional charge
            will also be payable if the debtis passed to our debt recovery
            company to cover our reasonable costs.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="7.8" class="col-1"><h5>7.8</h5></div>
        <div class="col-11">
          <p>
            All amounts due under the Contract shall be paid in full without any
            set-off, counterclaim, deduction or withholding (other than any
            deduction or withholding of tax as required by law).
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="8.0" class="col-1"><h2>8.</h2></div>
        <div class="col-11"><h3>INTELLECTUAL PROPERTY RIGHTS</h3></div>
      </div>
      <div class="row">
        <div id="8.1" class="col-1"><h5>8.1</h5></div>
        <div class="col-11">
          <p>
            All Intellectual Property Rights in or arising out of or in
            connection with the Services (other than Intellectual Property
            Rights in any materials provided by the Customer) shall be owned by
            ERCCIS or its licensors.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="8.2" class="col-1"><h5>8.2</h5></div>
        <div class="col-11">
          <p>
            ERCCIS grants to the Customer, or shall procure the direct grant to
            the Customer of, a licence during the term of the Contract to copy
            and modify any materials (excluding materials provided by the
            Customer) for the purpose of receiving and using the Services.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="8.3" class="col-1"><h5>8.3</h5></div>
        <div class="col-11">
          <p>
            The Customer shall not sub-license, assign or otherwise transfer the
            rights granted in clause 8.2.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="8.4" class="col-1"><h5>8.4</h5></div>
        <div class="col-11">
          <p>
            The Customer grants ERCCIS a fully paid-up, irrevocable,
            non-exclusive, royalty-free, non-transferable licence to copy and
            modify any materials (including Biological Records) provided by the
            Customer to ERCCIS.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="9.0" class="col-1"><h2>9.</h2></div>
        <div class="col-11"><h3>DATA PROTECTION</h3></div>
      </div>
      <div class="row">
        <div id="9.1" class="col-1"><h5>9.1</h5></div>
        <div class="col-11">
          <p>
            All data will be handled in accordance with ERCCIS’s
            <a href="/privacy-policy">Privacy Policy</a>.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="10.0" class="col-1"><h2>10.</h2></div>
        <div class="col-11">
          <h3>
            LIMITATION OF LIABILITY: THE CUSTOMER'S ATTENTION IS PARTICULARLY
            DRAWN TO THIS CLAUSE
          </h3>
        </div>
      </div>
      <div class="row">
        <div id="10.1" class="col-1"><h5>10.1</h5></div>
        <div class="col-11">
          <p>
            Nothing in these Terms limits any liability which cannot legally be
            limited, including, but not limited to, liability for:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="10.1.1" class="col-1"><h5>10.1.1</h5></div>
        <div class="col-10">
          <p>death or personal injury caused by negligence; and</p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="10.1.2" class="col-1"><h5>10.1.2</h5></div>
        <div class="col-10"><p>fraud or fraudulent misrepresentation.</p></div>
      </div>
      <div class="row">
        <div id="10.2" class="col-1"><h5>10.2</h5></div>
        <div class="col-11">
          <p>
            Subject to clause 10.1, ERCCIS shall not be liable to the Customer,
            whether in contract, tort (including negligence), for breach of
            statutory duty, or otherwise, arising under or in connection with
            these Terms for any indirect or consequential loss, including but
            not limited to loss of profits, sales or business, agreements or
            contracts, anticipated savings, use or corruption of software, data
            or information, and damage to goodwill.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="10.3" class="col-1"><h5>10.3</h5></div>
        <div class="col-11">
          <p>
            Subject to clauses 10.1 and 10.2, ERCCIS’s total liability to the
            Customer, whether in contract, tort (including negligence), breach
            of statutory duty, or otherwise, arising under or in connection with
            these Terms shall be limited to the amount paid under these Terms 12
            months prior to the claim.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="10.4" class="col-1"><h5>10.4</h5></div>
        <div class="col-11">
          <p>This clause 10 shall survive termination of the Contract.</p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="11.0" class="col-1"><h2>11.</h2></div>
        <div class="col-11"><h3>TERMINATION</h3></div>
      </div>
      <div class="row">
        <div id="11.1" class="col-1"><h5>11.1</h5></div>
        <div class="col-11">
          <p>
            Without affecting any other right or remedy available to it, the
            Customer may terminate the Contract by requesting Account
            cancellation to ERCCIS. ERCCIS will then have 20 Business Days to
            cease all Services and delete the Account.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="11.2" class="col-1"><h5>11.2</h5></div>
        <div class="col-11">
          <p>
            Without affecting any other right or remedy available to it, either
            party may terminate the Contract with immediate effect by giving
            written notice to the other party if the other party:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.2.1" class="col-1"><h5>11.2.1</h5></div>
        <div class="col-10">
          <p>
            commits a material breach of any term of the Contract and (if such a
            breach is remediable) fails to remedy that breach within 20 Business
            Days of that party being notified in writing to do so;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.2.2" class="col-1"><h5>11.2.2</h5></div>
        <div class="col-10">
          <p>
            takes any step or action in connection with its entering
            administration, provisional liquidation or any composition or
            arrangement with its creditors (other than in relation to a solvent
            restructuring), being wound up (whether voluntarily or by order of
            the court, unless for the purpose of a solvent restructuring),
            having a receiver appointed to any of its assets or ceasing to carry
            on business or, if the step or action is taken in another
            jurisdiction, in connection with any analogous procedure in the
            relevant jurisdiction;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.2.3" class="col-1"><h5>11.2.3</h5></div>
        <div class="col-10">
          <p>
            suspends, or threatens to suspend, or ceases or threatens to cease
            to carry on all or a substantial part of its business; or
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.2.4" class="col-1"><h5>11.2.4</h5></div>
        <div class="col-10">
          <p>
            suffers a deterioration in their financial position to such an
            extent that in the terminating party's opinion the other party's
            capability to adequately fulfil its obligations under the Contract
            has been placed in jeopardy.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="11.3" class="col-1"><h5>11.3</h5></div>
        <div class="col-11">
          <p>
            Without affecting any other right or remedy available to it, ERCCIS
            may suspend the supply of Services under the Contract if:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.3.1" class="col-1"><h5>11.3.1</h5></div>
        <div class="col-10">
          <p>
            the Customer fails to pay any amount due under the Contract on the
            due date for payment;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.3.2" class="col-1"><h5>11.3.2</h5></div>
        <div class="col-10">
          <p>
            the Customer becomes subject to any of the events listed in clause
            11.2.2to clause 11.2.4, or ERCCIS reasonably believes that the
            Customer is about to become subject to any of them; or
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.3.3" class="col-1"><h5>11.3.3</h5></div>
        <div class="col-10">
          <p>
            aninvestigation is required into alleged misuse of the Services in
            contravention of the ERCCIS Terms of Use.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="11.4" class="col-1"><h5>11.4</h5></div>
        <div class="col-11">
          <p>
            Without affecting any other right or remedy available to it, ERCCIS
            may terminate the Contract with immediate effect by giving written
            notice to the Customer if the Customer:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.4.1" class="col-1"><h5>11.4.1</h5></div>
        <div class="col-10">
          <p>
            fails to pay any amount due under the Contract on the due date for
            payment;
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="11.4.2" class="col-1"><h5>11.4.2</h5></div>
        <div class="col-10">
          <p>
            is proven, at ERCCIS’s sole discretion, to have misused the Services
            in contravention of the ERCCIS Terms of Use.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="12.0" class="col-1"><h2>12.</h2></div>
        <div class="col-11"><h3>CONSEQUENCES OF TERMINATION</h3></div>
      </div>
      <div class="row">
        <div id="12.1" class="col-1"><h5>12.1</h5></div>
        <div class="col-11">
          <p>
            On termination of the Contract the Customer shall immediately pay to
            ERCCIS all of ERCCIS's outstanding unpaid invoices and interest and,
            in respect of Services supplied but for which no invoice has been
            submitted, ERCCIS shall submit an invoice, which shall bepayable by
            the Customer immediately on receipt.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="12.2" class="col-1"><h5>12.2</h5></div>
        <div class="col-11">
          <p>
            Termination or expiry of the Contract shall not affect any rights,
            remedies, obligations or liabilities of the parties that have
            accrued up to the date of termination or expiry, including the right
            to claim damages in respect of any breach of the Contract which
            existed at or before the date of termination or expiry.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="12.3" class="col-1"><h5>12.3</h5></div>
        <div class="col-11">
          <p>
            Any provision of the Contract that expressly or by implication is
            intended to come into or continue in force on or after termination
            or expiry ofthe Contract shall remain in full force and effect.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="13.0" class="col-1"><h2>13.</h2></div>
        <div class="col-11"><h3>FORCE MAJEURE</h3></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            Neither party shall be in breach of the Contract nor liable for
            delay in performing, or failure to perform, any of its obligations
            under the Contract if such delay or failure result from events,
            circumstances or causes beyond its reasonable control.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="14.0" class="col-1"><h2>14.</h2></div>
        <div class="col-11"><h3>CONFIDENTIALITY</h3></div>
      </div>
      <div class="row">
        <div id="14.1" class="col-1"><h5>14.1</h5></div>
        <div class="col-11">
          <p>
            Each party undertakes that it shall not at any time during the
            Contract, and for a period of five years after termination of the
            Contract, disclose to any person any confidential information
            concerning the business, affairs, customers, clients or suppliers of
            the other party, except as permitted by clause 14.2.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="14.2" class="col-1"><h5>14.2</h5></div>
        <div class="col-11">
          <p>
            Each party may disclose the other party's confidential information:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="14.2.1" class="col-1"><h5>14.2.1</h5></div>
        <div class="col-10">
          <p>
            o its employees, officers, representatives, subcontractors or
            advisers who need to know such information for the purposes of
            carrying out the party's obligations under the Contract. Each party
            shall ensure that its employees, officers, representatives,
            subcontractors or advisers to whom it discloses the other party's
            confidential information comply with this clause 14; and
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div id="14.2.2" class="col-1"><h5>14.2.2</h5></div>
        <div class="col-10">
          <p>
            as may be required by law, a court of competent jurisdiction or any
            governmental or regulatory authority.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="14.3" class="col-1"><h5>14.3</h5></div>
        <div class="col-11">
          <p>
            Neither party shall use the other party's confidential information
            for any purpose other than to perform its obligations under the
            Contract.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="15.0" class="col-1"><h2>15.</h2></div>
        <div class="col-11"><h3>VARIATION</h3></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            Except as set out in these Terms, no variation of the Contract shall
            be effective unless it is in writing and signed by the parties (or
            their authorised representatives).
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="13.0" class="col-1"><h2>16.</h2></div>
        <div class="col-11"><h3>SEVERANCE</h3></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            If any provision or part-provision of the Contract is or becomes
            invalid, illegal or unenforceable, it shall be deemed modified to
            the minimum extent necessary to make it valid, legal and
            enforceable. If such modification is not possible, the relevant
            provision or part-provision shall be deemed deleted. Any
            modification to or deletion of a provision or part-provision under
            this clause 16 shall not affect the validity and enforceability of
            the rest of the Contract.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="17.0" class="col-1"><h2>17.</h2></div>
        <div class="col-11"><h3>ENTIRE AGREEMENT ANDVARIATION</h3></div>
      </div>
      <div class="row">
        <div id="17.1" class="col-1"><h5>17.1</h5></div>
        <div class="col-11">
          <p>
            This Contract constitutes the entire agreement between the parties
            and supersedes and extinguishes all previous drafts, agreements,
            arrangements and understandings between them, whether written or
            oral, relating to its subject matter.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="17.2" class="col-1"><h5>17.2</h5></div>
        <div class="col-11">
          <p>
            Each party agrees that it shall have no remedies in respect of any
            representation or warranty (whether made innocently or negligently)
            that is not set out in this Contract. Each party agrees that its
            only liability in respect of those representations and warranties
            that are set out in this Contract (whether made innocently or
            negligently) shall be for breach of contract.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="17.3" class="col-1"><h5>17.3</h5></div>
        <div class="col-11">
          <p>
            No variation of this Contract shall be effective unless it is in
            writing and signed by each of the parties (or their authorised
            representatives).
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="18.0" class="col-1"><h2>18.</h2></div>
        <div class="col-11"><h3>NO WAIVER</h3></div>
      </div>
      <div class="row">
        <div id="18.1" class="col-1"><h5>18.1</h5></div>
        <div class="col-11">
          <p>
            Failure to exercise, or any delay in exercising, any right or remedy
            provided under this Contract or by law shall not constitute a waiver
            of that or any otherright or remedy, nor shall it preclude or
            restrict any further exercise of that or any other right or remedy.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="18.2" class="col-1"><h5>18.2</h5></div>
        <div class="col-11">
          <p>
            No single or partial exercise of any right or remedy provided under
            this Contract or by law shall preclude or restrict the further
            exercise of that or any other right or remedy.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="19.0" class="col-1"><h2>19.</h2></div>
        <div class="col-11"><h3>ASSIGNMENT</h3></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            Except as otherwise provided in this Contract, no party may assign,
            sub-contract or deal in any way with, any of its rights or
            obligations under this Contract or any document referred to in it.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="20.0" class="col-1"><h2>20.</h2></div>
        <div class="col-11"><h3>NOTICES</h3></div>
      </div>
      <div class="row">
        <div id="20.1" class="col-1"><h5>20.1</h5></div>
        <div class="col-11">
          <p>
            A notice given to a party under or in connection with this Contract
            shall be in writing and sent to the party at the address given in
            this Contract or as otherwise notified in writing to the other
            party.
          </p>
        </div>
      </div>
      <div class="row">
        <div id="20.2" class="col-1"><h5>20.2</h5></div>
        <div class="col-11">
          <p>
            The following table sets out methods by which a notice maybe sent
            and its corresponding deemed delivery date and time:
          </p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <table class="table" border="solid 1px black">
            <tr>
              <th scope="col">Delivery method</th>
              <th scope="col">Deemed delivery date and time</th>
            </tr>
            <tr scope="row">
              <td>
                Delivery by hand or courier to the registered office or director
                of a party.
              </td>
              <td>
                On signature of a delivery receipt or at the time the notice is
                left at the address.
              </td>
            </tr>
            <tr scope="row">
              <td>
                Pre-paid first class post or other next working day delivery
                service providing proof of postage to the address provided upon
                registering the Account.
              </td>
              <td>
                Midday on the second Business Day after posting or at the time
                recorded by the delivery service –whichever is earlier.
              </td>
            </tr>
            <tr scope="row">
              <td>
                Email to an address detailed upon registering the Account.
              </td>
              <td>
                At the time of transmission if on a Business Day, otherwise at
                10:00 on the next Business Day after transmission.
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div id="20.3" class="col-1"><h5>20.3</h5></div>
        <div class="col-11">
          <p>
            This clause does not apply to the service of any proceedings or
            other documents in any legal action or, where applicable, any
            arbitration or other method of dispute resolution.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="21.0" class="col-1"><h2>21.</h2></div>
        <div class="col-11"><h3>NO PARTNERSHIP</h3></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            Nothing in this Contract is intended to, or shall be deemed to,
            establish any partnership or joint venture between any of the
            parties, constitute any party the agent of another party, nor
            authorise any party to make or enter into any commitments for or on
            behalf of any other party.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="22.0" class="col-1"><h2>22.</h2></div>
        <div class="col-11"><h3>THIRD PARTY RIGHTS</h3></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            A person who is not a party to this Contract shall not have any
            rights under or in connection with it.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div id="23.0" class="col-1"><h2>23.</h2></div>
        <div class="col-11"><h3>GOVERNING LAW AND JURISDICTION</h3></div>
      </div>
      <div class="row justify-content-end">
        <div class="col-11">
          <p>
            The validity, construction and performance of the Contract shall be
            governed by English law and shall be subject to the exclusive
            jurisdiction of the English courts to which the Partiessubmit.
          </p>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="col"><p>Version 1.0 August 2019</p></div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Terms",
  components: {
    MainNav,
    Footer
  }
};
</script>
